type ContactWithPhone = {
  contact_phone?: string | null;
};

// У подписанта нет поля телефона в форме, а бэкенд валидирует contact_phone
// регуляркой ^\+*\d{10,15}$ и не принимает пустую строку. Поле необязательное,
// поэтому пустое значение не отправляем вовсе
export const withoutEmptyContactPhones = <T extends ContactWithPhone>(
  contacts: T[],
): T[] =>
  (contacts || []).map((contact) => {
    if (contact.contact_phone?.trim()) return contact;

    const { contact_phone, ...withoutPhone } = contact;

    return withoutPhone as T;
  });
